import React from 'react';
import { Box, Typography, Button, Stack, Paper } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import EditIcon from '@mui/icons-material/Edit';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

import CohortDetails from "./CohortInfo";

import { GPAP_Button, GPAP_Button_Light } from '../../../../gpap-lib/components/Button_Collection';

const SelectedCohortMessage = ({ selected, cohortObj, createStudyCohort, changeCohort }) => {
  return (
    <Paper elevation={2} sx={{ padding: 2, backgroundColor: '#f0f8ff' }}> {/* Light blue background for visual feedback */}
      <Stack direction="row" alignItems="center" spacing={2} mb={2}>
        <CheckCircleOutlineIcon color="success" fontSize="large" />
        <Typography variant="h6" color="success">Cohort Selected Successfully</Typography>
        <Typography variant="body2">
            Click on <i>Create Cohort Study</i> to proceed.
      </Typography>
      </Stack>
      
      <CohortDetails cohortData = {cohortObj}/>
      {/* <Typography variant="body1">
        Cohort: <strong>{selected?.value}</strong>
      </Typography> */}
      
      <Stack direction="row" spacing={2} mt={2} justifyContent="flex-end">
        <GPAP_Button
          onClick={createStudyCohort}
          disabled={!selected}
          startIcon={<AddCircleOutlineIcon />}
        >
          Create Cohort Study
        </GPAP_Button>
        <GPAP_Button_Light
          onClick={() => changeCohort()}
          disabled={!selected}
          startIcon={<EditIcon />}
        >
          Change Cohort
        </GPAP_Button_Light>
      </Stack>
    </Paper>
  );
};

export default SelectedCohortMessage;